module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "search-button",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "backdrop",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('div', {
    staticClass: "search-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "search-header"
  }, [_c('div', {
    staticClass: "filler"
  }), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "search",
      "placeholder": "Enter Search Term (min 3 chars)"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": function($event) {
        $event.keyCode === 32 ?
          $event.preventDefault() :
          _vm.startSearch(_vm.searchCount)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fa-stack",
    staticStyle: {
      "margin-right": "0"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-1x icon-background"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times fa-stack-1x icon",
    on: {
      "click": function($event) {
        (_vm.searchTerm = null), _vm.resetSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fa-stack"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-1x icon-background"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times fa-stack-1x icon",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "search-menu"
  }, _vm._l((_vm.sections), function(section) {
    return _c('div', {
      key: section,
      class: {
        active: _vm.selected == section
      },
      on: {
        "click": function($event) {
          _vm.selected = section
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm._f("deslugify")(section)) + "\n          (" + _vm._s(_vm.results[section].count) + ")\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('loader')], 1) : (!_vm.results[_vm.selected].count) ? _c('div', {
    staticClass: "no-results"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.searchTerm ?
    ("No " + (_vm.noResultsText[_vm.selected]) + " found") :
    "Enter Search Term") + "\n          ")])]) : _c('scroll-area', {
    ref: "scrollbar",
    attrs: {
      "showScrollbar": true,
      "dragScrollEnabled": false
    }
  }, [(_vm.selected == 'videos') ? _c('div', {
    staticClass: "videos"
  }, _vm._l((_vm.results.videos.results), function(video) {
    return _c('router-link', {
      key: video.video_title,
      attrs: {
        "to": {
          name: 'videoPlayer',
          params: {
            courseId: video.course_id,
            instanceId: video.instance_id,
            videoId: video.video_id,
          },
          query: {
            term: video.term,
            week: video.week
          },
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "background",
      attrs: {
        "src": video.thumbnail
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "play-button",
      attrs: {
        "src": require("../../assets/img/play-button.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h4', {
      domProps: {
        "innerHTML": _vm._s(video.title_highlights)
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s("Week " + video.week + " - " + video.course_name))])])])
  })) : (_vm.selected == 'resources') ? _c('div', {
    staticClass: "resources"
  }, _vm._l((_vm.results.resources.results), function(resource) {
    return _c('a', {
      key: resource.name,
      attrs: {
        "href": !resource.videoId ?
          resource.url :
          (_vm.baseUrl + "videos/" + (resource.courseId) + "/" + (resource.instanceId) + "/" + (resource.videoId) + "?week=" + (resource.week) + "&tab=resources")
      },
      on: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    }, [_c('h4', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(resource.name_highlights)
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(resource.description_highlights)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "course"
    }, [_vm._v("\n                " + _vm._s(resource.video.title +
      ", Week " +
      resource.week +
      " - " +
      resource.course.name) + "\n              ")])])
  })) : (_vm.selected == 'KB') ? _c('div', {
    staticClass: "kb"
  }, _vm._l((_vm.results.KB.results), function(article) {
    return _c('router-link', {
      key: article.title,
      attrs: {
        "title": article.title,
        "to": {
          name: 'KB Article',
          params: {
            articleId: article.id
          },
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    }, [_c('h4', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(article.title_highlights)
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(article.overview_highlights)
      }
    })])
  })) : (_vm.selected == 'forum') ? _c('div', {
    staticClass: "forum"
  }, _vm._l((_vm.results.forum.results), function(post) {
    return _c('div', {
      key: post.id
    }, [_c('h4', [_c('router-link', {
      attrs: {
        "to": _vm.getThreadUrl(post)
      },
      domProps: {
        "innerHTML": _vm._s(post.title_highlights)
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    })], 1), _vm._v(" "), _c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(post.body_highlights)
      }
    }), _c('router-link', {
      attrs: {
        "to": _vm.getThreadUrl(post)
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    }, [_vm._v("\n                  Read Forum Post\n                ")])], 1), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v("\n                -\n                "), _c('i', [_vm._v(_vm._s(post.author.firstName) + " " + _vm._s(post.author.lastName))]), _vm._v("\n                @ " + _vm._s(_vm._f("shortDate")(post.createdAt)) + " in\n                "), _c('router-link', {
      attrs: {
        "to": {
          name: 'forum-category',
          params: {
            categorySlug: post.thread.category.name
          },
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.closeSearch()
        }
      }
    }, [_vm._v("\n                  " + _vm._s(post.thread.category.label) + "\n                ")])], 1)])
  })) : (_vm.selected == 'chat') ? _c('div', {
    staticClass: "chat"
  }, _vm._l((_vm.results.chat.results), function(message) {
    return _c('div', {
      key: message._id
    }, [_c('p', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(message.msg))
      }
    }), _c('a', {
      attrs: {
        "href": 'https://chat.tttc.ca/channel/' +
          _vm.nameFromId(message.rid) +
          '?msg=' +
          message._id,
        "target": "_blank"
      }
    }, [_vm._v("\n                  Read in Think Tank Chat\n                ")])]), _vm._v(" "), _c('p', {
      staticClass: "author"
    }, [_vm._v("\n                - "), _c('i', [_vm._v(_vm._s(message.u.username) + " ")]), _vm._v(" @\n                " + _vm._s(message.ts || _vm.shortDate) + " in\n                "), _c('a', {
      attrs: {
        "href": 'https://chat.tttc.ca/channel/' + _vm.nameFromId(message.rid),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.nameFromId(message.rid))))])])])
  })) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-pagination"
  }, _vm._l((_vm.results[_vm.selected].pages), function(i) {
    return _c('div', {
      key: i,
      class: {
        active: _vm.offsets[_vm.selected] + 1 == i
      },
      on: {
        "click": function($event) {
          _vm.offsets[_vm.selected] = i - 1;
          _vm.search(_vm.selected);
        }
      }
    }, [_vm._v("\n          " + _vm._s(i) + "\n        ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0270d69c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Search.vue
// module id = 1938
// module chunks = 2